import TeamLogo from "../team/logo";
import { formatDiff } from "@/utils";
import { Rank, RANKS, TeamBasic } from "common";

export interface BadgeProps {
  rank: number;
  units: number;
  team: TeamBasic;
  year: number;
}


export default function Badge(props: BadgeProps) {
  return (
    <div className="flex items-center gap-4 min-w-[152px]">
      <div>
        <div className="w-16 h-16 justify-center items-center flex rounded-[9.6px_9.6px_38.4px_38.4px] backdrop-blur-[11.2px] bg-[linear-gradient(117deg,#20272E_6.85%,#0C0D0F_122.24%)]">
          <TeamLogo team={props.team} />
          <div className="absolute -top-2 -right-[10px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="27"
              height="30"
              viewBox="0 0 27 30"
              fill="none"
            >
              <path
                d="M20.2522 29.1007C20.4455 29.4768 20.9831 29.4768 21.1763 29.1007L22.5775 26.3736C22.6271 26.2771 22.7057 26.1986 22.8022 26.149L25.5293 24.7478C25.9054 24.5545 25.9054 24.0169 25.5293 23.8237L22.8022 22.4225C22.7057 22.3729 22.6271 22.2943 22.5775 22.1978L21.1763 19.4707C20.9831 19.0946 20.4455 19.0946 20.2522 19.4707L18.851 22.1978C18.8015 22.2943 18.7229 22.3729 18.6264 22.4225L15.8993 23.8237C15.5232 24.0169 15.5232 24.5545 15.8993 24.7478L18.6264 26.149C18.7229 26.1986 18.8015 26.2771 18.851 26.3736L20.2522 29.1007Z"
                fill="#B1ED40"
              />
              <path
                d="M17.5148 11.0557C17.7177 11.4506 18.2823 11.4506 18.4852 11.0557L19.9564 8.19229C20.0085 8.09096 20.091 8.00847 20.1923 7.95641L23.0557 6.48516C23.4506 6.28226 23.4506 5.71774 23.0557 5.51484L20.1923 4.04359C20.091 3.99153 20.0085 3.90904 19.9564 3.80771L18.4852 0.94426C18.2823 0.549356 17.7177 0.549356 17.5148 0.94426L16.0436 3.80771C15.9915 3.90904 15.909 3.99153 15.8077 4.04359L12.9443 5.51484C12.5494 5.71774 12.5494 6.28226 12.9443 6.48516L15.8077 7.95641C15.909 8.00847 15.9915 8.09096 16.0436 8.19229L17.5148 11.0557Z"
                fill="#B1ED40"
              />
              <path
                d="M4.71069 13.8495L6 16.3589L7.28931 13.8495C7.41296 13.6089 7.60887 13.413 7.84953 13.2893L10.3589 12L7.84953 10.7107C7.60887 10.587 7.41296 10.3911 7.28931 10.1505L6 7.64111L4.71069 10.1505C4.58704 10.3911 4.39113 10.587 4.15046 10.7107L1.64111 12L4.15047 13.2893C4.39113 13.413 4.58704 13.6089 4.71069 13.8495Z"
                stroke="#B1ED40"
                strokeWidth="1.5"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-1">
          <div className="uppercase text-title-sm-bold text-secondary-300">
            Rank {props.rank}
          </div>
          {props.rank < 5 && (
            <img
              src={`/images/bettor/crowns/${RANKS[props.rank as Rank]}.webp`}
              alt={`${RANKS[props.rank as Rank]} crown`}
              className="w-6 h-6 block"
            />
          )}
        </div>
        <div className="text-title-sm-medium text-secondary-300">
          {props.team.abbreviation} {props.year}
        </div>
        <div className="text-title-sm-medium text-secondary-500">
          {formatDiff(props.units)}
        </div>
      </div>
    </div>
  );
}
